export default __webpack_public_path__ + "static/media/kitchen5-beforeC-480w.8c90ec72.avif";